<template lang="pug">
    section
        input.mb10(v-if="filter", v-model="filterValue")
        ul.hz-tree(ref="treeContainer", v-if="data && data[defaultProps.label]")
            li(tabindex="0", :data-key="data[nodeKey]")
                span.tree-button.switch.root_open(@click.stop="handleRootSwitchClick")
                span.tree-button.chk.checkbox_false_full(v-if="showCheckbox", @click.stop="handleRootCbxClick(data, $event)")
                a(v-if="contextmenu", :class="{'curSelectedNode': setRootSelect}", :title="data[defaultProps.label]", @contextmenu.prevent="handleRightMenu(data, $event)", @click="handleNodeClick(data, $event)")
                    i.fa(v-if="data[defaultProps.icon]", :class="[data[defaultProps.icon]]", style="margin: 0 5px")
                    span.node_name {{data[defaultProps.label]}}
                a(v-else, :class="{'curSelectedNode': setRootSelect}", :title="data[defaultProps.label]", @click="handleNodeClick(data, $event)")
                    i.fa(v-if="data[defaultProps.icon]", :class="[data[defaultProps.icon]]", style="margin: 0 5px")
                    span.node_name {{data[defaultProps.label]}}    
                TreeItem(v-if="data[defaultProps.children]", :data="data[defaultProps.children]")
                .tree-contextmenu(v-show="visible", :style="{left:left+'px',top:top+'px'}")
                    slot(name="contextmenu", :data="data", :item="rightMenuItem")
</template>
<script>
import TreeItem from './treeItem'
export default {
    name: 'hz-tree',
    components: {
        TreeItem
    },
    props: {
        data             : { type: Object, default: function(){ return {}} },
        setRootSelect    : { type: Boolean, default: true},                         //默认设置根节点选中
        filter           : { type: Boolean, default: false },                       //是否显示过滤搜索框
        expandAll        : { type: Boolean, default: false },                       //是否展开所有节点
        showLine         : { type: Boolean, default: true },                        //是否显示连接线
        showCheckbox     : { type: Boolean, default: false },                       //是否显示checkbox
        nodeKey          : { type: String, default: 'id' },
        contextmenu      : { type: Boolean, default: false },                       //是否有右键菜单
        contextmenuClick : { type: Boolean, default: true },                       //右键菜单是否触发点击事件
        checkRelate      : { type: Boolean, default: true },                       //勾选是否关联父子节点
        lazy             : { type: Boolean, default: false },                      //是否懒加载
        multiple         : { type: Boolean, default: false },                      //节点是否可以多选
        defaultProps     : { type: Object, default: function(){ return {children: 'children', label: 'name', isLeaf: 'isLeaf', icon: 'icon'}}}

    },
    provide(){
        return {
            expandAll        : this.expandAll,
            showLine         : this.showLine,
            showCheckbox     : this.showCheckbox,
            defaultProps     : this.defaultProps,
            nodeKey          : this.nodeKey,
            contextmenu      : this.contextmenu,
            checkRelate      : this.checkRelate,
            lazy             : this.lazy,
            multiple         : this.multiple
        }
    },
    data(){
        return {
            visible: false,
            left: 0,
            top: 0,
            rightMenuItem: {},
            filterValue: ''
        }
    },
    watch: {
        'filterValue': function(val, oldVal){
            if(!val){
                $(this.$refs.treeContainer).find("li[data-key]").show();
            }else{
                $(this.$refs.treeContainer).find(".node_name").each((index, item) => {
                    const value = $(item).html();
                    if(value.indexOf(val) != -1){
                        $(item).parents("li[data-key]").show();
                    }else{
                        $(item).closest("li[data-key]").hide();
                    }
                })
            }
        }
    },
    computed: {
        dataArray(){
            return hz.tools.obj.treeObjToArray(this.data)
        }
    },
    created(){
        this.$on("rightMenu", ({item ,e}) => {
            this.handleRightMenu(item, e)
        })
    },
    mounted(){
        const $self = this;
        $(document).on("click", function(){
            $self.visible = false;
        });
    },
    destroyed(){
        // $(document).off("click");
    },
    methods: {
        //获取选中的node
        getCheckedNodes(){
            const keys = this.getCheckedKeys();
            return keys.length ? this.dataArray.filter(item => {
                return keys.indexOf(item[this.nodeKey]) > -1
            }) : [];
        },
        //获取选中的keys
        getCheckedKeys(){
            const resultKeys = [];
            $(this.$refs.treeContainer).find(".checkbox_true_full").each(function(index, item){
                resultKeys.push($(item).closest("li").data("key"))
            })
            return resultKeys;
        },

        //获取所有选中的叶子节点Nodes
        getLeafCheckedNodes(){
            const keys = this.getLeafCheckedKeys();
            return keys.length ? this.dataArray.filter(item => {
                return keys.indexOf(item[this.nodeKey]) > -1
            }) : [];
        },

        //获取所有选中的叶子节点Keys
        getLeafCheckedKeys(){
            const resultKeys = [];
            $(this.$refs.treeContainer).find(".checkbox_true_full").each(function(index, item){
                const $obj = $(item).closest("li");
                if(!$obj.find("ul").length){
                    resultKeys.push($obj.data("key"))
                }
            })
            return resultKeys;
        },
        //通过node设置选中
        setCheckedNodes(nodeArray){
            nodeArray.map(item => {
                const $el = $(this.$refs.treeContainer).find("li[data-key= " + item[this.nodeKey] + "]");

                if(this.checkRelate){
                    $el.find(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                    ([].some).call($el.parents("li"), function(li){
                        const $li = $(li);
                        const rs = ([].every).call($li.find(">ul >li").children(".chk"), function(cbx){
                            return $(cbx).hasClass("checkbox_true_full");
                        })
                        if(rs){
                            $li.children(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                            return false;
                        }else{
                            return true;
                        }
                    })
                }else{
                    $el.children(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                }
                
            })
        },
        //通过key设置选中
        setCheckedKeys(keyArray){
            keyArray.map(item => {
                const $el =  $(this.$refs.treeContainer).find("li[data-key= " + item + "]");
                if(this.checkRelate){
                     $el.find(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                    ([].some).call($el.parents("li"), function(li){
                        const $li = $(li);
                        const rs = ([].every).call($li.find(">ul >li").children(".chk"), function(cbx){
                            return $(cbx).hasClass("checkbox_true_full");
                        })
                        if(rs){
                            $li.children(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                            return false;
                        }else{
                            return true;
                        }
                    })
                }else{
                    $el.children(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                }
            })
        },
        //重置选中按钮
        resetChecked(){
            $(this.$refs.treeContainer).find(".checkbox_true_full")
                .addClass("checkbox_false_full").removeClass("checkbox_true_full");
        },

        //通过id数组设置checkbox禁用
        setCheckedDisabledKeys(keyArray){
            keyArray.map(item => {
                const $el =  $(this.$refs.treeContainer).find("li[data-key= " + item + "]");
                $el.children(".chk").removeClass("checkbox_false_full checkbox_true_full").addClass("checkbox_false_disable");
            })
        },

        //通过node数组设置checkbox禁用
        setCheckedDisabledNodes(nodeArray){
            nodeArray.map(item => {
                const $el =  $(this.$refs.treeContainer).find("li[data-key= " + item[this.nodeKey] + "]");
                $el.children(".chk").removeClass("checkbox_false_full checkbox_true_full").addClass("checkbox_false_disable");
            })
        },

        //node点击事件
        handleNodeClick(item, e){
            if(item.disabled) return ;

            const $el = $(e.target).closest("a");
            if(!this.multiple){
                $el.closest(".hz-tree").find(".curSelectedNode").removeClass("curSelectedNode")
            }
            $el.addClass("curSelectedNode")
            this.$emit('node-click', item);
        },

        //右键菜单点击事件
        handleRightMenu(item, e){
            if(this.contextmenuClick){
                this.handleNodeClick(item, e);
            }
            this.visible = true
            this.left = e.clientX
            this.top = e.clientY
            this.rightMenuItem = item
        },
        handleRootSwitchClick(e){
            const $el = $(e.target)
            if($el.hasClass("root_open")){
                $el.nextAll('ul').slideUp("fast");
            }else{
                $el.nextAll('ul').slideDown("fast");
            }
            $el.toggleClass("root_open root_close")
        },
        handleRootCbxClick(data, e){
            const $el = $(e.target)
            const $parent = $el.parent();
            if($el.hasClass("checkbox_false_disable")) return;
            if(this.checkRelate){
                if($el.hasClass("checkbox_true_full")){
                    //未选中
                    $parent.find(".chk").removeClass("checkbox_true_full").addClass("checkbox_false_full");
                }else{
                    //选中
                    $parent.find(".chk").removeClass("checkbox_false_full").addClass("checkbox_true_full");
                }
            }else{
                $el.toggleClass("checkbox_true_full checkbox_false_full")
            }
            const flag = $el.hasClass("checkbox_true_full");
            this.$emit("check-click", data, flag)
        },

        setCurrentKey(key){
            const $el =  $(this.$refs.treeContainer).find("li[data-key= " + key + "]");
            if(!this.multiple){
                $el.closest(".hz-tree").find(".curSelectedNode").removeClass("curSelectedNode")
            }
            $el.children("a").addClass("curSelectedNode")
            const itemObj = this.dataArray.find(item => key == item[this.nodeKey])
            this.$emit('node-click', itemObj);
        },
        
        setCurrentNode(node){
            const $el =  $(this.$refs.treeContainer).find("li[data-key= " + node[this.nodeKey] + "]");
            if(!this.multiple){
                $el.closest(".hz-tree").find(".curSelectedNode").removeClass("curSelectedNode")
            }
            $el.children("a").addClass("curSelectedNode")
            const itemObj = this.dataArray.find(item => node[this.nodeKey] == item[this.nodeKey])
            this.$emit('node-click', itemObj);
        },

        //设置接点选中，树形下拉框使用
        setCurrentKeyTree(keys){
             if(Object.prototype.toString.call(keys) == '[object Array]'){
                if(!this.multiple){
                    console.error("该树形结构不支持多选，请设置multiple属性支持多选..")
                }else{
                    keys.map(item => {
                        const $el =  $(this.$refs.treeContainer).find("li[data-key= " + item + "]");
                        $el.children("a").addClass("curSelectedNode")
                    })
                }
            }else{
                if(!keys) return ;
                const $el =  $(this.$refs.treeContainer).find("li[data-key= " + keys + "]");
                $el.closest(".hz-tree").find(".curSelectedNode").removeClass("curSelectedNode")
                $el.children("a").addClass("curSelectedNode")
            }
        },
        cancelCurrentKey(key){
            const $el =  $(this.$refs.treeContainer).find("li[data-key= " + key + "]");
            $el.children("a").removeClass("curSelectedNode")
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/tree.vue